
 const dateTimeFormats = {
        'fr-FR': {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            }
        }
    }

    export default dateTimeFormats;